import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography } from "@material-ui/core";
import { MovementPalletCard } from "./MovementPalletCard";
import { SummaryHeader } from "../shared/SummaryHeader";

export const MovementResult = ({ result, classes }) => {
	const translate = useTranslate();

	return (
		<Box className={classes.resultGroup}>
			<SummaryHeader
				classes={classes}
				rows={[
					{ label: translate("resources.storage-transactions.fields.from_place"), value: result.from_place_address },
					{ label: translate("resources.storage-transactions.fields.to_place"), value: result.to_place_address },
					{ label: translate("resources.storage-transactions.fields.context_id"), value: result.context_id },
				]}
				transactionsCreated={result.transactions_created}
				timestamp={result.timestamp}
			/>

			<Box className={classes.palletColumnFull}>
				<Box className={`${classes.columnHeader} ${classes.columnHeaderMoved}`}>
					<Typography className={classes.columnHeaderText}>
						{translate("resources.storage-transactions.dialogs.pallets_moved")} ({result.movements.length})
					</Typography>
				</Box>
				{result.movements.length > 0 ? (
					result.movements.map((pallet) => (
						<MovementPalletCard key={pallet.pallet_id} pallet={pallet} classes={classes} />
					))
				) : (
					<Box className={classes.emptyState}>
						<Typography>{translate("resources.storage-transactions.dialogs.no_pallets_moved")}</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};
